import classNames from 'classnames/bind';
import styles from './projectCopyright.module.css';
import Item from '../Item';
import InputRow from '../InputRow';
import { COPYRIGHT_INFO_LIST } from '../../../../constants';

export default function projectCopyright({ id }: any) {
  const cx = classNames.bind(styles);

  return (
    <Item id={id} innerClass="s_min">
      {COPYRIGHT_INFO_LIST.map(([title, key]) => (
        <InputRow key={key} name={key} title={title} />
      ))}
    </Item>
  );
}
